export default __webpack_public_path__ + "static/media/contact-figure.9b01dfc6.svg";